import { PMDialog } from "../../utils/PMDialog";

export const DrawingModuleConfigDialog = ({
  t,
  moduleConfigDialog,
  saving,
  onClose,
  onChange,
  onSave,
}) => {
  return (
    <PMDialog
      open={!!moduleConfigDialog}
      onClose={onClose}
      title={t("drawings.module.rectangular")}
      size="md"
    >
      {moduleConfigDialog && (
        <div className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              {t("drawings.module.color")}
            </label>
            <input
              type="color"
              value={moduleConfigDialog.color || "#000000"}
              onChange={(e) =>
                onChange((prev) => ({
                  ...prev,
                  color: e.target.value,
                }))
              }
              className="h-10 w-full rounded"
            />
          </div>
          <div>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={moduleConfigDialog.filled || false}
                onChange={(e) =>
                  onChange((prev) => ({
                    ...prev,
                    filled: e.target.checked,
                  }))
                }
              />
              <span>{t("drawings.module.filled")}</span>
            </label>
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-300 px-4 py-2"
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              onClick={onSave}
              disabled={saving}
                className="rounded-lg bg-[#2b6ef0] px-4 py-2 text-white disabled:bg-gray-400"
            >
              {saving ? t("Saving...") : t("Update")}
            </button>
          </div>
        </div>
      )}
    </PMDialog>
  );
};
